import { graphql } from "@/lib/gql/__generated__/gql";

export const ExistingOptionI18n_EditPage_Query = graphql(`
	query ExistingOptionI18n($hotelID: ID!, $optionID: ID!, $lang: LangCode!) {
		optionI18n(hotelID: $hotelID, optionID: $optionID, lang: $lang) {
			id
			lang
			hotelID
			optionID
			name
			description
			subOptions {
				subOptionID
				name
				startAt
				endAt
				isNextMorning
				memo
				maxDailyStockNum
				price {
					currencyType
					amount
				}
				isShowTimeSchedule
			}
		}
	}
`);
